import { useContext, useEffect } from "react";
import { AppContext, LinkButton } from "./Layout";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURL, STORAGEURL } from "..";
import Loading from "../components/UI/Loading";
import parse from 'html-react-parser'
import FeedbackSwiper from "../components/FeedbackSwiper";
import Formular from "../components/Formular";

import hp_pattern from "../assets/svg/hp_pattern.svg";
import workshop_icons from '../assets/svg/workshop_icons.svg'
import KartySwiper from "../components/KartySwiper";


const Workshop = () => {
    const { language, pages, setPages } = useContext(AppContext)||{};
    const data = pages.workshop;
    const navigate = useNavigate(); 

    const getPageData = async () => {  
        await axios.post(APIURL+'/page', {name: 'workshop', language: language}).then(async response =>{
            setPages((prev)=>({ ...prev, workshop:response.data.body}));
        }).catch(()=>{
        navigate('/')
        })
    } 
    useEffect(() => {
        if (!pages?.workshop) {
          getPageData();
        }
      }, [pages]);

    if (!data) {return <Loading />} else 
    return (
        <main className="flex flex-col items-center gap-14 mobil:gap-7">
            <div className="maxSection flex flex-col justify-center items-center text-center min-h-[40vh] max-h-[800px]">
                <img src={workshop_icons} className="absolute mobil:hidden -z-10 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-h-full max-w-[80%]" alt="" />
                <h1>{data.intro_title}</h1>
                <p className="text-purplee-400 pb-7 font-semibold">{data.intro_text}</p>
                <LinkButton to="#form" type='workshop' className="mobil:!w-full" />
            </div>
            {data.intro_banner&&<img src={STORAGEURL+data.intro_banner} className="maxSection rounded-xl w-full mobil:aspect-square object-cover" alt="workshop" />}
            <div className="maxSection text-center mobil:py-7">
                <h2>{data.reasons_title}</h2>
                <p className="text-purplee-400">{data.reasons_text}</p>
                {data.reasons_questions&&<div className="pt-14 w-full">
                    <div className="m-auto w-3/5 nemobil:max-w-xl mobil:w-full mobil:-mb-14">
                        <img src={hp_pattern} className="w-full absolute left-0 top-1/2 -translate-y-1/2 mobil:hidden" alt="" />
                        <img src={STORAGEURL+data.reasons_img} className="w-full" alt="Otazky" />
                    </div>
                    <div className="nemobil:absolute w-full h-full left-0 top-0 otazky">{parse(data.reasons_questions)}</div>
                </div>}
            </div>
            <div className="maxSection">
                <h2 className="text-center">Ceník</h2>
                <div className="flex mobil:flex-col gap-7 tablet:gap-4 py-7 mb-7">
                    {data.pricing_items?.map(i=>(
                        <div key={i.item_name} className={"basis-full bg-white p-7 tablet:p-4 rounded-xl "+(i.comment?'extragap':'')}>
                            <p className={"font-bold "+(i.item_name.toLowerCase().includes('workshop')?(i.item_name.toLowerCase().includes('full')?'text-transparent bg-clip-text bg-gradient-to-r from-emerald-500 from-10% via-purplee-100 via-30% to-pinkk-100 to-90% w-fit':'text-pinkk-100'):'text-purplee-100')}>{i.item_name}</p>
                            <strong className="text-3xl pt-2 pb-4 block">{i.price}&nbsp;Kč <sub className="font-light text-lg">vč.&nbsp;DPH</sub></strong>
                            <div className="box_ul mb-4">{parse(i.list)}</div>
                            <Link className={"button "+(i.item_name.toLowerCase().includes('workshop')?"!bg-pinkk-100":"bg-purplee-100")} to="#form">{i.button_text}</Link>
                            
                            {i.comment&&<div className="absolute w-full -z-10 top-[calc(100%-1rem)] p-2 pt-5 rounded-bl-xl rounded-br-xl left-0 bg-purplee-200 text-xs text-center">{parse(i.comment||"")}</div>}
                        </div>
                    ))}
                </div>
                <div className="w-full bg-purplee-500 text-white flex mobil:hidden p-7 rounded-xl">
                    <div className="basis-1/2 pr-7 border-r border-white">
                        <h4 className="text-white">Workshop</h4>
                        <div className="parsedDiv [&_p]:text-sm [&_p]:pt-4 [&_strong]:text-base [&_strong]:!font-normal">{parse(data.pricing_workshop||"")}</div>
                    </div>
                    <div className="basis-1/2 pl-7">
                        <h4 className="text-white">Startovací analýza</h4>
                        <div className="parsedDiv [&_p]:text-sm [&_p]:pt-4 [&_strong]:text-base [&_strong]:!font-normal">{parse(data.pricing_analyza||"")}</div>
                    </div>
                </div>
            </div>
            {data.reviews_items?.length&&<div className="w-full">
                <h2 className="m-auto max-w-md text-center">{data.reviews_title}</h2>
                <FeedbackSwiper items={data.reviews_items} />
            </div>}
            <Formular className="maxSection" name='workshop' title={data.form_title} text={data.form_text} />
            <div className="maxSection">
                <div className="hpSection items-center mobil:flex-col-reverse gap-y-7">
                    <KartySwiper />
                    <div>
                        <h2>{data.cards_title}</h2>
                        <p>{data.cards_subtitle}</p>
                        <span>{data.cards_text}</span>
                        <LinkButton type="karty" />
                    </div>
                </div>
            </div>
            
        </main>
    )
}
export default Workshop;